import { render, staticRenderFns } from "./PriceguardStatisticsCard.vue?vue&type=template&id=634ef0bd"
import script from "./PriceguardStatisticsCard.vue?vue&type=script&lang=js"
export * from "./PriceguardStatisticsCard.vue?vue&type=script&lang=js"
import style0 from "./PriceguardStatisticsCard.vue?vue&type=style&index=0&id=634ef0bd&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634ef0bd')) {
      api.createRecord('634ef0bd', component.options)
    } else {
      api.reload('634ef0bd', component.options)
    }
    module.hot.accept("./PriceguardStatisticsCard.vue?vue&type=template&id=634ef0bd", function () {
      api.rerender('634ef0bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Debugger/PriceguardStatisticsCard.vue"
export default component.exports